import { JUNCTURES_LIST_BY_PROPERTY } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case JUNCTURES_LIST_BY_PROPERTY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case JUNCTURES_LIST_BY_PROPERTY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case JUNCTURES_LIST_BY_PROPERTY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
